export default __webpack_public_path__ + "27ad53a.png";